import { Core } from '@strapi/strapi';
import { KoniBotServiceType } from "./services/bot/koni-bot";
import {SynchronizeActionServiceType} from "./services/bot/synchronize-action";

export default ({ strapi }: { strapi: Core.Strapi }) => {
  // Stop the bot
  strapi.plugin('telegram-bot').service<KoniBotServiceType>('koniBot').stop().catch(console.error);
  strapi.plugin('telegram-bot').service<SynchronizeActionServiceType>('synchronizeAction').stopCrawlerBot().catch(strapi.log.error);
  // destroy phase
};
